import { CloseOutlined } from '@ant-design/icons'
import { Button, Flex, Form, Input } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = StepProps

export const StepEndCallConditions: React.FC<Props> = props => {
  return (
    <CommonClient.Onboarding.Step {...props}>
      <TitlePrimary level={4} style={{ marginBottom: '32px' }}>
        Under which conditions should I end a call?
      </TitlePrimary>

      <Flex vertical className="w-full">
        <CommonClient.Form.InputWrapper children={null} />

        <Form.List name={['instructions', 'endCallConditions']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => (
                <Flex key={field.key} style={{ width: '100%' }}>
                  <Form.Item
                    {...field}
                    name={[field.name]}
                    rules={[{ required: true, message: 'Required' }]}
                    style={{ flex: 1 }}
                  >
                    <Input placeholder="Enter condition" />
                  </Form.Item>

                  {fields.length > 1 && (
                    <Button
                      type="text"
                      icon={<CloseOutlined />}
                      onClick={() => remove(field.name)}
                    />
                  )}
                </Flex>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  disabled={fields.length >= 5}
                >
                  Add Condition
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Flex>
    </CommonClient.Onboarding.Step>
  )
}
